import contentPages from '../generated/content-pages.json';
import { SECTION_INDEX_PATHS } from './localeRoutes';

export const NAV_SECTIONS_BY_LOCALE = {
  fr: [
    { key: 'hub', contentSection: 'hub' },
    { key: 'solutions', contentSection: 'solutions', indexPath: SECTION_INDEX_PATHS.solutions },
    { key: 'secteurs', contentSection: 'secteurs', indexPath: SECTION_INDEX_PATHS.secteurs },
    { key: 'comparatifs', contentSection: 'comparatifs', indexPath: SECTION_INDEX_PATHS.comparatifs },
    { key: 'articles', contentSection: 'articles', indexPath: SECTION_INDEX_PATHS.articles },
  ],
  en: [
    { key: 'hub', contentSection: 'hub-en' },
    { key: 'solutions', contentSection: 'solutions-en', indexPath: '/en/solutions/' },
    { key: 'comparatifs', contentSection: 'comparatifs-en', indexPath: '/en/comparisons/' },
    { key: 'articles', contentSection: 'articles', indexPath: '/articles/' },
  ],
};

export const NAV_STATIC_PAGES_BY_LOCALE = {
  fr: [{ path: '/devis/', titleKey: 'navPages.quote' }],
  en: [{ path: '/en/quote/', titleKey: 'navPages.quote' }],
};

function sortPages(pages, locale) {
  const collator = new Intl.Collator(locale === 'en' ? 'en' : 'fr', { sensitivity: 'base' });
  return [...pages].sort((a, b) => collator.compare(a.title, b.title));
}

export function buildNavPageSections(locale) {
  const sections = NAV_SECTIONS_BY_LOCALE[locale] || NAV_SECTIONS_BY_LOCALE.fr;

  return sections
    .map(({ key, contentSection, indexPath }) => {
      const pages = sortPages(
        Object.values(contentPages[contentSection] || {}).map(({ path, title, slug }) => ({
          path,
          title,
          slug,
        })),
        locale,
      );

      if (pages.length === 0) return null;

      return { key, indexPath, pages };
    })
    .filter(Boolean);
}

export function getNavStaticPages(locale) {
  return NAV_STATIC_PAGES_BY_LOCALE[locale] || NAV_STATIC_PAGES_BY_LOCALE.fr;
}
